import { render, staticRenderFns } from "./InviteNewUser.vue?vue&type=template&id=0ce52d70&"
import script from "./InviteNewUser.vue?vue&type=script&lang=js&"
export * from "./InviteNewUser.vue?vue&type=script&lang=js&"
import style0 from "./InviteNewUser.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports